module.exports = __webpack_public_path__ + "img/middle2.189b751b.png";